import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import strFunc from "@/lib/lyg/string";

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    goDelete: (inData: any) => { },
    is_show_detail: false,
    set_is_show_detail: (inData: boolean) => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    let change_list_opt: any = {
      ...myProps.listOpt,
    };
    change_list_opt[name] = value;

    myProps.list({
      ...change_list_opt,
      now_page: 1
    });
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    let change_list_opt = {
      now_page: 1,
      [key]: date_str
    };
    if (key == "s_start_date") {
      change_list_opt["s_end_date"] = date_str;
    }
    myProps.list(change_list_opt);
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const goDateDayChange = (inData: any) => {
    let opt_obj = {
      "sort": "month",//day
      "pre_next": "pre",
      ...inData
    };
    //next,pre
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (opt_obj.pre_next == "pre") {
      if (opt_obj.sort == "month") {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
      } else {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'day', -1);
      }
    } else if (opt_obj.pre_next == "next") {
      if (opt_obj.sort == "month") {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
      } else {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'day', +1);
      }
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-d");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-d");
    if (opt_obj.sort == "month") {
      start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
      end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    }

    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div>
      <div className="my_flex_center">
        <span className="text-blue-700">
          {listOpt.s_start_date.substring(5, 7)} 월
        </span>
        {year_month_num_arr.map((row_num) => {
          let btn_class_name = "btn btn-dark ml-1";
          let select_month_num = parseInt(listOpt.s_start_date.substring(5, 7));
          if (select_month_num == row_num) {
            btn_class_name = "btn btn-blue ml-1";
          }
          return (
            <button key={row_num} className={btn_class_name}
              onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
          );
        })}
        <div style={{ display: "inline-block", width: 90 }}>
          <DatePicker
            wrapperClassName="pl-1"
            selected={listOpt.s_start_date != "" ? new Date(listOpt.s_start_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_start_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </div>
        ~
        <div style={{ display: "inline-block", width: 90 }}>
          <DatePicker
            wrapperClassName="pl-1"
            selected={listOpt.s_end_date != "" ? new Date(listOpt.s_end_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_end_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </div>
        <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange({ pre_next: "pre" }); }}>◀</button>
        <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange({ pre_next: "next" }); }}>▶</button>
        <select className="search-input" name="s_in_out" value={listOpt.s_in_out} onChange={on_change_search_input}>
          <option value="">구분</option>
          <option value="out">판매</option>
          <option value="in">입고</option>
        </select>
        <input type="text" name="s_title_like" value={listOpt.s_title_like} onChange={on_change_search_input}
          className="search-input pl-1" placeholder="제목" style={{ width: "80px" }} />
        <input type="text" name="s_user_name_like" value={listOpt.s_user_name_like} onChange={on_change_search_input}
          className="search-input pl-1" placeholder="주문자" style={{ width: "80px" }} />
        <input type="text" name="s_mcomp_name_like" value={listOpt.s_mcomp_name_like} onChange={on_change_search_input}
          className="search-input pl-1" placeholder="학원" style={{ width: "80px" }} />
        <button className='btn btn-dark'>검색</button>
        <button className='btn btn-red'
          onClick={() => {
            myProps.goDelete({});
          }}>삭제</button>

        <span className="ml-2">
          <label>
            <input type="checkbox" className="mr-1" checked={myProps.is_show_detail}
              onChange={(e) => { myProps.set_is_show_detail(e.target.checked); }} />
            주문상세보기
          </label>
        </span>
      </div>
    </div>
  );
};
export default SearchArea;